'use strict';
//添加全局过滤器资源
export default {
    install: function(Vue, options) {

        //过滤图片字符串中的地址，如果有图http则不加图片服务器地址，否则加上服务器地址
        Vue.filter('replaceImgSrc', function(src, size) {

            if (!src) {
                return;
            }
            if (src.indexOf('http') > -1) {

                return src

            } else {
                if (size == 100) {
                    return '//sz.cnbooking.net' + src;

                }
                var picName = src.split('.')[src.split('.').length - 1];
                return '//sz.cnbooking.net' + src.replace(/(jpg|png|gif)$/i, 'auto.s' + size + '.' + picName);
            }

        });
        //过滤图片字符串中的地址，如果有图http则不加图片服务器地址，否则加上服务器地址
        Vue.filter('replaceCImgSrc', function(src) {

            if (!src) {
                return;
            }
            return 'https://t.cnbooking.net' + src;

        });

        //将数字转化为带两个小数点
        Vue.filter('numberFloat', function(number) {
            if (!number) {
                return '0.00';
            }
            var temp = parseInt(number * 100) / 100
            return temp.toFixed(2)
        });
        //去掉数字两个小数点
        Vue.filter('numberFloatDel', function(number) {
            if (!number) {
                return '0';
            }
            var temp = parseInt(number * 100) / 100
            return temp.toFixed(0)
        });
        //日期期格式化为 00月00日 
        Vue.filter('dateShort', function(date) {
            if (!date) return '';
            var da = new Date(date);
            var month = da.getMonth() + 1;
            var day = da.getDate();

            return (month < 10 ? ('0' + month) : month) + '月' + (day < 10 ? ('0' + day) : day) + '日';

        });

        //日期期格式化为 00.00 
        Vue.filter('dateMMDD', function(date) {
            if (!date) return '';
            var da = new Date(date);
            var month = da.getMonth() + 1

            if (month < 10) { month = '0' + month };
            var date = da.getDate();
            if (date < 10) { date = '0' + date };
            return month + '.' + date;

        });
        //日期期格式化为 00-00 
        Vue.filter('dateMMtDD', function(date) {
            if (!date) return '';
            var da = new Date(date);
            var month = da.getMonth() + 1

            if (month < 10) { month = '0' + month };
            var date = da.getDate();
            if (date < 10) { date = '0' + date };
            return month + '-' + date;

        });
        //倒计时格式化为 00.00 
        Vue.filter('secondCount', function(second) {
            if (!second) return '';
            var minutes = parseInt(second / 60)
            var seconds = parseInt(second % 60);
            return '0' + minutes + ':' + seconds;
        });
        //日期期格式化周几
        Vue.filter('dateWeek', function(date) {
            var nowDate = new Date();
            var days = getDays(nowDate, date);

            var mydate = new Date(date);

            var myday = mydate.getDay() //注:0-6对应为星期日到星期六 
            var xingqi;
            switch (myday) {
                case 0:
                    xingqi = "周日";
                    break;
                case 1:
                    xingqi = "周一";
                    break;
                case 2:
                    xingqi = "周二";
                    break;
                case 3:
                    xingqi = "周三";
                    break;
                case 4:
                    xingqi = "周四";
                    break;
                case 5:
                    xingqi = "周五";
                    break;
                case 6:
                    xingqi = "周六";
                    break;
                default:
                    xingqi = ""
            }

            if (days == 0) {
                return '今天';
            } else if (days == 1) {
                return '明天';
            } else if (days == 2) {
                return '后天';
            } else {
                return xingqi;
            }



        });
        //日期期格式化星期几
        Vue.filter('dateWeekFormat', function(date) {
            var nowDate = new Date();
            var days = getDays(nowDate, date);

            var mydate = new Date(date);

            var myday = mydate.getDay() //注:0-6对应为星期日到星期六 
            var xingqi;
            switch (myday) {
                case 0:
                    xingqi = "星期天";
                    break;
                case 1:
                    xingqi = "星期一";
                    break;
                case 2:
                    xingqi = "星期二";
                    break;
                case 3:
                    xingqi = "星期三";
                    break;
                case 4:
                    xingqi = "星期四";
                    break;
                case 5:
                    xingqi = "星期五";
                    break;
                case 6:
                    xingqi = "星期六";
                    break;
                default:
                    xingqi = ""
            }


            return xingqi;




        });
        //日期期格式化为 0000-00
        Vue.filter('dateToMonth', function(date) {
            if (!date) return '';

            var da = new Date(date);
            var year = da.getFullYear() + '-';

            var month = da.getMonth() + 1;

            if (month < 10) { month = '0' + month };
            return year + month;

        });

        //日期期格式化为 0000年00月00日
        Vue.filter('dateToYMD', function(date) {
            if (!date) return '';

            var da = new Date(date);
            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            var day = da.getDate();

            if (month < 10) { month = '0' + month };
            if (day < 10) { day = '0' + day };
            return year + '年' + month + '月' + day + '日';

        });
        //日期期格式化为 0000-00-00
        Vue.filter('dateToYMDline', function(date) {
            if (!date) return '';

            var da = new Date(date);
            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            var day = da.getDate();

            if (month < 10) { month = '0' + month };
            if (day < 10) { day = '0' + day };
            return year + '-' + month + '-' + day;

        });
        //日期期格式化为 0000.00.00
        Vue.filter('dateYYMMDD', function(date) {
            if (!date) return '';

            var da = new Date(date);
            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            var day = da.getDate();

            if (month < 10) { month = '0' + month };
            if (day < 10) { day = '0' + day };
            return year + '.' + month + '.' + day;

        });
        //日期期格式化为 0000-00-00 00:00:00
        Vue.filter('dateLongToYMDline', function(date) {
            if (!date) return '';
            date.replace('T', '');

            var da = new Date(date);
            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            var day = da.getDate();

            if (month < 10) { month = '0' + month };
            if (day < 10) { day = '0' + day };

            var hour = da.getHours();
            if (hour < 10) {
                hour = '0' + hour;

            }
            var minutes = da.getMinutes();
            if (minutes < 10) {
                minutes = '0' + minutes;

            }
            var second = da.getSeconds();
            if (second < 10) {
                second = '0' + second;

            }
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + second;

        });
        //日期期格式化为 0000年00月00日 时00分00秒 
        Vue.filter('dateLong', function(date) {

            var da = new Date(date);

            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;

            }
            var day = da.getDate();
            if (day < 10) {
                day = '0' + day;

            }

            var hour = da.getHours();
            if (hour < 10) {
                hour = '0' + hour;

            }
            var minutes = da.getMinutes();
            if (minutes < 10) {
                minutes = '0' + minutes;

            }
            var second = da.getSeconds();
            if (second < 10) {
                second = '0' + second;

            }

            return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + second;

        });
        //截取字符串长度
        Vue.filter('stringLength', function(str, length) {


            var str = str;
            if (str && str.length > 15) {
                str = str.substring(0, 15) + '...'
            }
            return str

        })
    }
};
// 计算日期差
function getDays(s1, s2) {
    var year = s1.getFullYear() + '-';
    var month = s1.getMonth() + 1 + '-';
    var day = s1.getDate() + '-';

    if (month < 10) { month = '0' + month };
    s1 = year + month + day;

    s1 = new Date(s1.replace(/-/g, "/"));
    s2 = new Date(s2.replace(/-/g, "/"));

    var days = s2.getTime() - s1.getTime();
    var time = parseInt(days / (1000 * 60 * 60 * 24));

    return time;
}


// WEBPACK FOOTER //
// ./src/components/common/filters.js